import { MessageEl } from './MessageEl';
import { NavigateButton } from './NavigateButton';

export const seCeErrors = {
  DEFAULT: {
    title: 'Something went wrong',
    message: (
      <MessageEl
        preText="We weren't able to set up your account. Please contact support "
        linkText="helpme@support.veeqo.com"
        href="mailto:helpme@support.veeqo.com"
      />
    ),
    rightActions: [
      <NavigateButton href="mailto:helpme@support.veeqo.com" text="Contact support" />,
    ],
  },
  INVALID_INPUT: {
    title: 'Something went wrong',
    message: (
      <MessageEl
        preText="We weren't able to set up your account. Please contact support "
        linkText="helpme@support.veeqo.com"
        href="mailto:helpme@support.veeqo.com"
      />
    ),
    rightActions: [
      <NavigateButton href="mailto:helpme@support.veeqo.com" text="Contact support" />,
    ],
  },
  INTERNAL_ERROR: {
    title: 'Something went wrong',
    message: (
      <MessageEl
        preText="We weren't able to set up your account. Please contact support "
        linkText="helpme@support.veeqo.com"
        href="mailto:helpme@support.veeqo.com"
      />
    ),
    rightActions: [
      <NavigateButton href="mailto:helpme@support.veeqo.com" text="Contact support" />,
    ],
  },
  INVALID_EMAIL: {
    title: 'Invalid email address',
    message: (
      <MessageEl preText="Your Amazon Seller email address isn't valid or is already a Veeqo user. Please try signing in to Veeqo" />
    ),
    rightActions: [<NavigateButton href="https://app.veeqo.com/signin" text="Sign in to Veeqo" />],
  },
  INSUFFICIENT_PERMISSIONS: {
    title: 'Insufficient permissions',
    message: (
      <MessageEl
        preText="Please ask the "
        postText="of your Amazon Seller account to create a Veeqo account"
        linkText="owner"
        href="https://sellercentral.amazon.com/account/permissions/"
      />
    ),
    rightActions: [<NavigateButton href="https://app.veeqo.com/signin" text="Create account" />],
  },
  MULTIPLE_STORE_COLLECTION: {
    title: 'Something went wrong',
    message: (
      <MessageEl
        preText="We weren't able to set up your account. Please contact support "
        linkText="helpme@support.veeqo.com"
        href="mailto:helpme@support.veeqo.com"
      />
    ),
    rightActions: [
      <NavigateButton href="mailto:helpme@support.veeqo.com" text="Contact support" />,
    ],
  },
  STORE_CONNECTION_ERROR: {
    title: 'Amazon Store connection',
    message: (
      <MessageEl
        preText="We weren't able to connect your Amazon Store. Please sign in to Veeqo and try again"
        linkText="Click here to retry"
        href={window.location.href}
      />
    ),
    rightActions: [<NavigateButton href="https://app.veeqo.com/signin" text="Sign in to Veeqo" />],
  },
};
